import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import PublicReceipt from "@/pages/PublicReceipt";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/r/:hash" element={<PublicReceipt />} />
      </Routes>
      <Toaster
        position="bottom-right"
        toastOptions={{
          className: "rounded-none border-zinc-800 bg-zinc-900 text-zinc-100",
        }}
      />
    </BrowserRouter>
  );
}

export default App;
